import React, { useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useIntl } from 'react-intl';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import { Avatar, Badge, IconButton, Tooltip } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useSelector } from 'store';

const SystemNotifications = () => {
    const navigate = useNavigate();
    const anchorRef = useRef<HTMLDivElement | null>(null);
    const intl = useIntl();
    const { productsToApproveCount } = useSelector((state) => state.product);
    const { productErrors } = useSelector((state) => state.product);

    const HeaderAvatarStyle = styled(Avatar)(({ theme }) => ({
        ...theme.typography.commonAvatar,
        ...theme.typography.mediumAvatar,
        background: theme.palette.mode === 'dark' ? theme.palette.dark.main : theme.palette.secondary.light,
        color: theme.palette.mode === 'dark' ? theme.palette.warning.main : theme.palette.warning.dark,
        '&:hover': {
            background:
                productsToApproveCount === 0
                    ? theme.palette.mode === 'dark'
                        ? theme.palette.primary.main
                        : theme.palette.secondary.dark
                    : '',
            color: theme.palette.mode === 'dark' ? 'white' : theme.palette.secondary.light
        },
        cursor: productsToApproveCount !== 0 ? 'pointer' : ''
    }));

    const redirect = () => {
        navigate('/loolu/admin/products/pending_approvals');
    };

    const totalNotificationsCount = () => {
        const errors = [...productErrors.product, ...productErrors.sku];
        return productsToApproveCount + errors.length;
    };

    return (
        <>
            <Tooltip title={intl.formatMessage({ id: 'notifications_text' })} placement="bottom">
                <Badge badgeContent={totalNotificationsCount()} color="error" sx={{ mr: 2, ml: 2 }}>
                    <HeaderAvatarStyle variant="rounded" ref={anchorRef} aria-haspopup="true" sx={{ display: { md: 'flex' } }}>
                        <IconButton color="inherit" disabled={!productsToApproveCount} onClick={redirect}>
                            <NotificationsActiveIcon />
                        </IconButton>
                    </HeaderAvatarStyle>
                </Badge>
            </Tooltip>
        </>
    );
};

export default SystemNotifications;
